import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { fetchGamesList, searchGames } from "../../services/axios/apiManager";
import LoadingSpinner from "../../Components/spinner";
import { gameTypes } from "../../services/staticData";

const Filters = ({ pagination, genres, tagsData, languages, setGames }) => {
  const [query, setQuery] = useState("");
  const [filtering, setFiltering] = useState(false);
  const [filters, setFilters] = useState({
    status: "",
    tag: "",
    language: "",
    genre: "",
    type: "",
  });

  // // // status = 0-Inactive, 1-Active, 2-deleted, 3 default
  // // // Fetch Filtered Permission
  const fetchGames = async (string = "") => {
    setFiltering(true);
    const res = await fetchGamesList(
      pagination.currentPage,
      pagination.pageSize,
      string
    );
    if (res?.data?.data) {
      setGames(res.data.data);
    }
    setFiltering(false);
  };

  const makeFilterString = async (e) => {
    const temp = { ...filters };
    temp[e.target.name] = e.target.value;
    setFilters({ ...temp });
    let string = "";
    if (temp?.status?.length > 0) {
      string += `&status=${temp.status}`;
    }
    if (temp?.tag?.length > 0) {
      string += `&tag=${temp.tag}`;
    }
    if (temp?.language?.length > 0) {
      string += `&language=${temp.language}`;
    }
    if (temp?.genre?.length > 0) {
      string += `&genre=${temp.genre}`;
    }
    if (temp?.type?.length > 0) {
      string += `&type=${temp.type}`;
    }
    await fetchGames(string);
  };

  // // // Search by name/company
  const handleSearch = async (e) => {
    const string = e.target.value;
    setQuery(string);
    if (string.length > 0) {
      setFiltering(true);
      const results = await searchGames(string);
      if (results?.data?.data) {
        setGames(results.data.data);
      }
      setFiltering(false);
    } else {
      await fetchGames();
    }
  };
  // // // Reset All Filters to default
  const resetFilters = async () => {
    setFilters({
      status: "",
      tag: "",
      language: "",
      genre: "",
      type: "",
    });
    setQuery("");
    await fetchGames();
  };
  return (
    <div className="col-md-10 row">
      <div className="col-md-3 py-2">
        <Form.Control
          type="text"
          placeholder="Search Games..."
          value={query}
          onChange={(e) => {
            handleSearch(e);
          }}
          className="bg-dark text-light border-light input-placeholder-light"
        />
      </div>
      <div className="col-md-3 py-2">
        <Form.Select
          name="genre"
          value={filters.genre}
          onChange={(e) => {
            makeFilterString(e);
          }}
          className="bg-dark border-light text-light"
        >
          <option value="">All Genres</option>
          {genres?.map((m) => (
            <option key={m} value={m}>
              {m}
            </option>
          ))}
        </Form.Select>
      </div>
      <div className="col-md-3 py-2">
        <Form.Select
          name="tag"
          value={filters.tag}
          onChange={(e) => {
            makeFilterString(e);
          }}
          className="bg-dark border-light text-light"
        >
          <option value="">All Tags</option>
          {tagsData?.map((m) => (
            <option key={m} value={m}>
              {m}
            </option>
          ))}
        </Form.Select>
      </div>
      <div className="col-md-3 py-2">
        <Form.Select
          name="language"
          value={filters.language}
          onChange={(e) => {
            makeFilterString(e);
          }}
          className="bg-dark border-light text-light"
        >
          <option value="">All Languages</option>
          {languages?.map((m, i) => (
            <option key={i} value={m.language}>
              {m.language}
            </option>
          ))}
        </Form.Select>
      </div>
      <div className="col-md-3 py-2">
        <Form.Select
          name="type"
          value={filters.type}
          onChange={(e) => {
            makeFilterString(e);
          }}
          className="bg-dark border-light text-light"
        >
          <option value="">All Types</option>
          {gameTypes?.map((m, i) => (
            <option key={i} value={m.type}>
              {m.type}
            </option>
          ))}
        </Form.Select>
      </div>
      <div className="col-md-3 py-2">
        <Form.Select
          name="status"
          value={filters.status}
          onChange={(e) => {
            makeFilterString(e);
          }}
          className="bg-dark border-light text-light"
        >
          <option value="3">Active & Inactive</option>
          <option value="1">Active</option>
          <option value="0">Inactive</option>
          <option className="text-danger" value="2">
            Deleted
          </option>
        </Form.Select>
      </div>
      <div className="col-md-1 py-2 mx-2" data-testid="loading-spinner">
        {filtering ? (
          <LoadingSpinner size={"md"} />
        ) : (
          <div className="row ">
            <Button
              title="Reset Filters And Rrfresh Records"
              className="btn btn-success"
              onClick={() => {
                resetFilters();
              }}
            >
              Reset
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
export default Filters;
